__turbopack_context__.v({
  "container": "CookiesBar-module-scss-module__FLO3Gq__container",
  "content": "CookiesBar-module-scss-module__FLO3Gq__content",
  "decline": "CookiesBar-module-scss-module__FLO3Gq__decline",
  "footer": "CookiesBar-module-scss-module__FLO3Gq__footer",
  "overlay": "CookiesBar-module-scss-module__FLO3Gq__overlay",
});
